export const FETCH_LOTTERIES = {
  LOADING: 'fetchLotteriesLoading',
  SUCCESS: 'fetchLotteriesSuccess',
  FAIL: 'fetchLotteriesFail',
};

export const FETCH_REFERRAL_CODE = {
  LOADING: 'fetchReferralCodeLoading',
  SUCCESS: 'fetchReferralCodeSuccess',
  FAIL: 'fetchReferralCodeFail',
};
